export interface Tab {
  name: string;
  current: boolean;
}

export const Tabs: Tab[] = [
  { name: 'Users', current: true },
  { name: 'Groups', current: false },
];
